import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ServiceTeasersContentModel } from '@libs/cms/models';
import { provideContentTrackingContext } from '@libs/shared/tracking';
import { ServiceTeaserComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-service-teasers',
  templateUrl: './service-teasers.component.html',
  styleUrls: ['./service-teasers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ServiceTeaserComponent,
  ],
  providers: [
    provideContentTrackingContext(ServiceTeasersComponent),
  ],
})
export class ServiceTeasersComponent extends ContentBaseComponent<ServiceTeasersContentModel> {
}
